// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-color);
}

.header__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
}

.header__logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
  text-decoration: none;
}

.logo-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  border-radius: 10px;
  font-weight: 700;
}

.logo-text {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header__nav {
  display: flex;
  gap: 32px;
  align-items: center;
}

.nav-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  position: relative;
}

.nav-link:hover {
  color: var(--primary-color);
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--primary-color);
  transition: width 0.3s;
}

.nav-link:hover::after {
  width: 100%;
}

.header__actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.header__menu-toggle {
  display: none;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.header__menu-toggle span {
  width: 24px;
  height: 2px;
  background: var(--text-primary);
  transition: all 0.3s;
}

.btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
  text-decoration: none;
  display: inline-block;
}

.btn--primary {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  box-shadow: var(--shadow);
}

.btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-lg);
}

.btn--ghost {
  background: transparent;
  color: var(--text-primary);
}

.btn--ghost:hover {
  background: var(--bg-secondary);
}

@media (max-width: 768px) {
  .header__nav {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    padding: 24px;
    gap: 16px;
    border-bottom: 1px solid var(--border-color);
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
  }

  .header__nav--open {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .header__menu-toggle {
    display: flex;
  }

  .header__actions {
    gap: 8px;
  }

  .btn {
    padding: 8px 16px;
    font-size: 13px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iFAAiF;EACjF,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iFAAiF;EACjF,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,4CAA4C;IAC5C,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".header {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1000;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  backdrop-filter: blur(10px);\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.header__content {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px 0;\r\n}\r\n\r\n.header__logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.logo-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  color: white;\r\n  border-radius: 10px;\r\n  font-weight: 700;\r\n}\r\n\r\n.logo-text {\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.header__nav {\r\n  display: flex;\r\n  gap: 32px;\r\n  align-items: center;\r\n}\r\n\r\n.nav-link {\r\n  color: var(--text-secondary);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: color 0.2s;\r\n  position: relative;\r\n}\r\n\r\n.nav-link:hover {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.nav-link::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -4px;\r\n  left: 0;\r\n  width: 0;\r\n  height: 2px;\r\n  background: var(--primary-color);\r\n  transition: width 0.3s;\r\n}\r\n\r\n.nav-link:hover::after {\r\n  width: 100%;\r\n}\r\n\r\n.header__actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.header__menu-toggle {\r\n  display: none;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 8px;\r\n}\r\n\r\n.header__menu-toggle span {\r\n  width: 24px;\r\n  height: 2px;\r\n  background: var(--text-primary);\r\n  transition: all 0.3s;\r\n}\r\n\r\n.btn {\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: all 0.2s;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n}\r\n\r\n.btn--primary {\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  color: white;\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.btn--primary:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.btn--ghost {\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.btn--ghost:hover {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .header__nav {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    right: 0;\r\n    background: white;\r\n    flex-direction: column;\r\n    padding: 24px;\r\n    gap: 16px;\r\n    border-bottom: 1px solid var(--border-color);\r\n    transform: translateY(-100%);\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: all 0.3s;\r\n  }\r\n\r\n  .header__nav--open {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n\r\n  .header__menu-toggle {\r\n    display: flex;\r\n  }\r\n\r\n  .header__actions {\r\n    gap: 8px;\r\n  }\r\n\r\n  .btn {\r\n    padding: 8px 16px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
